import request from '@/utils/request'

export function getPartnerData(data) {
  return request({
    url: '/Api/brand.BrandPartner/partner_list',
    method: 'post',
    data
  })
}

export function getApplyList(data) {
  return request({
    url: '/Api/brand.BrandPartner/apply_list',
    method: 'post',
    data
  })
}

export function handleApply(data) {
  return request({
    url: '/Api/brand.BrandPartner/handle_apply',
    method: 'post',
    data
  })
}
export function changeLevel(data) {
  return request({
    url: '/Api/brand.BrandPartner/changeLevel',
    method: 'post',
    data
  })
}

export function getDownload(data) {
  return request({
    url: '/Api/brand.BrandPartner/create_recruit_qrcode',
    method: 'post',
    data
  })
}
export function savePosterInfo(data) {
  return request({
    url: '/Api/brand.BrandPartner/savePoster',
    method: 'post',
    data
  })
}

export function Download_img(data) {
  return request({
    url: '/Api/brand.NoAuth/downRecruitQrcode',
    method: 'get',
    data
  })
}

export function getBrandConfig(data) {
  return request({
    url: '/Api/brand.Brand/getBrandConfig',
    method: 'post',
    data
  })
}

export function setBrandConfig(data) {
  return request({
    url: '/Api/brand.Brand/setBrandConfig',
    method: 'post',
    data
  })
}

export function getPartnerDetail(data) {
  return request({
    url: '/Api/brand.BrandPartner/partner_detail',
    method: 'post',
    data
  })
}

export function getSellProducts(data) {
  return request({
    url: '/Api/brand.BrandPartner/getSellProducts',
    method: 'post',
    data
  })
}

export function getApplyDetail(data) {
  return request({
    url: '/Api/brand.BrandPartner/apply_detail',
    method: 'post',
    data
  })
}
